import type { EntityBatchSyncStatus } from './entityMutationSync'
import { deriveSyncOutcome, type SyncOutcome } from './syncOutcome'

// Thin per-surface wrapper. Logic lives in `deriveSyncOutcome` so every
// surface stays in lockstep (v2.1 finding #24 consolidation). NOTE: the
// surface key is `task` (singular) but the i18n namespace is `tasks.sync.*`
// (plural) — the consolidated helper preserves that mapping in SURFACE_PREFIX.
export type TaskSyncOutcome = SyncOutcome

export const deriveTaskSyncOutcome = (params: {
  status: EntityBatchSyncStatus
  skippedNotFoundCount: number
}): TaskSyncOutcome => deriveSyncOutcome({ ...params, surfaceKey: 'task' })
